import { authHeader } from '../_helpers';
import axios from 'axios';

export const trackingService = {
  saveTracking,
  getTrackingsForUser,
  saveProfile,
  getProfile
};

async function saveTracking(tracking) {
  return axios.post(process.env.ROOT_API + '/api/v1/trackings', tracking, {
    headers: authHeader()
  });
}

async function getTrackingsForUser(id) {
  return axios.get(process.env.ROOT_API + '/api/v1/trackings/user/' + id, {
    headers: authHeader()
  });
}

async function saveProfile(profile) {
  return axios.post(`${process.env.ROOT_API}/api/v1/profiles`, profile, {
    headers: authHeader()
  });
}

async function getProfile(id) {
  return axios.get(process.env.ROOT_API + '/api/v1/profiles/' + id, {
    headers: authHeader()
  });
}



// WEBPACK FOOTER //
// ./src/_services/tracking.js